module.exports = __webpack_public_path__ + "static/media/webdesign-services-img34.6355f530.jpg";